import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'

class LoopingVideoComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
    }

    this.onLoadedData = this.onLoadedData.bind(this)
    this.onTimeUpdate = this.onTimeUpdate.bind(this)
    this.onEnded = this.onEnded.bind(this)
  }

  componentDidMount() {
    if (this.videoElement) {
      this.videoElement.addEventListener('loadeddata', this.onLoadedData)
      this.videoElement.addEventListener('timeupdate', this.onTimeUpdate)
      this.videoElement.addEventListener('ended', this.onEnded)
      this.videoElement.play()
    }
  }

  onLoadedData() {
    if (this.videoElement) {
      if (this.videoElement.readyState >= 4) {
        this.videoElement.play()
      }
    }
  }

  onTimeUpdate() {
    const { loopRange } = this.props
    this.setState({ loading: false })
    if (this.videoElement) {
      if (
        this.videoElement.currentTime < loopRange[0] ||
        this.videoElement.currentTime >= loopRange[1]
      ) {
        this.onEnded()
      }
    }
  }

  onEnded() {
    if (this.videoElement) {
      const { loopRange } = this.props
      const [time] = loopRange

      this.videoElement.currentTime = time
      this.videoElement.play()
    }
  }

  render() {
    const { loading } = this.state

    const { src } = this.props

    return (
      <div className="looping-video-component">
        <video
          ref={(videoElement) => {
            this.videoElement = videoElement
          }}
          src={src}
          muted
        />
        <div
          className="looping-video-spinner"
          style={{ opacity: loading ? 1 : 0 }}
        />
      </div>
    )
  }
}

LoopingVideoComponent.propTypes = {
  src: PropTypes.string.isRequired,
  loopRange: PropTypes.arrayOf(PropTypes.number).isRequired,
}

export default LoopingVideoComponent
